import { useEffect } from "react";
import Cookies from "js-cookie";

export default function ThirdPartyScripts() {
  useEffect(() => {
    const consent = Cookies.get("cookieConsent");

    if (consent === "accepted") {
      // Cargar Facebook Pixel
      const fb = document.createElement("script");
      fb.type = "text/partytown";
      fb.src = "/facebook-init.js"; // Mueve tu código de Pixel aquí
      document.body.appendChild(fb);

      // Cargar Google Tag Manager
      const gtm = document.createElement("script");
      gtm.type = "text/partytown";
      gtm.src = "/gtm-init.js"; // Mueve tu init de GTM aquí
      document.body.appendChild(gtm);

      // Google Analytics
      const ga = document.createElement("script");
      ga.type = "text/partytown";
      ga.src = "https://www.googletagmanager.com/gtag/js?id=G-2B8LD9XNLL";
      document.body.appendChild(ga);

      const gaConfig = document.createElement("script");
      gaConfig.type = "text/partytown";
      gaConfig.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-2B8LD9XNLL');
      `;
      document.body.appendChild(gaConfig);

      // Hotjar
      const hotjar = document.createElement("script");
      hotjar.type = "text/partytown";
      hotjar.src = "/hotjar-init.js";
      document.body.appendChild(hotjar);

      // TikTok
      const tiktok = document.createElement("script");
      tiktok.type = "text/partytown";
      tiktok.src = "/tiktok-init.js";
      document.body.appendChild(tiktok);
    }
  }, []);

  return null;
}